export const LOGIN_BG =
  "https://static.prod-images.emergentagent.com/jobs/6d69963b-3b6f-40d8-9455-2c8c018f2e84/images/120ee1cf2347759117640149e1b14ed5bed4b241368f3026c422c2474351fff2.png";

export const AlrLogo = ({ size = 96 }) => (
  <img src="/alr-ops-logo.png" alt="ALR Ops" data-testid="alr-logo" style={{ height: Math.round(size * 0.62), width: "auto" }} />
);

export const LanguagePill = ({ accent }) => (
  <button
    type="button"
    data-testid="language-selector"
    title="More languages are coming in a later phase"
    className="flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-bold tracking-[0.2em] bg-black/40 backdrop-blur-md"
    style={{ borderColor: `${accent}66`, color: accent }}
  >
    <span className="inline-block h-1.5 w-1.5 rounded-full" style={{ background: accent }} />
    EN
  </button>
);

export const LegalFooter = () => (
  <footer className="mt-12 text-center text-[11px] text-neutral-500" data-testid="legal-footer">
    <p>© 2026 Advanced Laser Restoration • Authorized Use Only</p>
    <div className="mt-2 flex justify-center gap-3">
      <a href="/terms" data-testid="footer-terms-link" className="underline hover:text-neutral-300">Terms</a>
      <span>·</span>
      <a href="/privacy" data-testid="footer-privacy-link" className="underline hover:text-neutral-300">Privacy</a>
    </div>
  </footer>
);
